;(function () {
	'use strict';//Indicating browser should run only in java script mode
	angular
		.module('EMR.Home')
		.service('ApptsInfoCommonService', ApptsInfoCommonService)

	ApptsInfoCommonService.$inject = ['CommonService'];

	function ApptsInfoCommonService(CommonService) {
		///*******PURPOSE:THIS METHOD IS USED TO GET THE CUSTOMIZED APPOINTMENT SETTINGS RELATED TO APPTS VIEW COLUMNS INFORMATION BLOCK START ##############################
		///*******CREATED BY: PAVAN KUMAR KANDULA
		///*******CREATED DATE:24/12/2018
		///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 
		var apptsInfoGetApptSchedulerApptsSettingsInfomationList = function (postData) {
			postData.practicemodel = EMRPracticeModel
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonService.PostData('POST', CommonService.EHR_AppointmentsTopHits_API() + "GetApptSchedulerApptsSettingsInfomationList", postData).then(
				function (result) {
					return result;
				});
		};
		//###################THIS METHOD IS USED TO GET THE CUSTOMIZED APPOINTMENT SETTINGS RELATED TO APPTS VIEW COLUMNS INFORMATION BLOCK END #########################

		///*******PURPOSE:THIS METHOD IS USED TO GET THE CUSTOMIZED APPOINTMENT COLUMNS INFORMATION RELATED TO APPTS VIEW COLUMNS INFORMATION BLOCK START ##############################
		///*******CREATED BY: PAVAN KUMAR KANDULA
		///*******CREATED DATE:24/12/2018
		///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 
		var apptsInfoGetApptSchedulerApptsCustomizedColumnsInfomationList = function (postData) {
			postData.practicemodel = EMRPracticeModel
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonService.PostData('POST', CommonService.EHR_AppointmentsTopHits_API() + "GetApptSchedulerApptsCustomizedColumnsInformationList", postData).then(
				function (result) {
					return result;
				});
		};
		//###################THIS METHOD IS USED TO GET THE CUSTOMIZED APPOINTMENT COLUMNS INFORMATION RELATED TO APPTS VIEW COLUMNS INFORMATION BLOCK END #########################

		//############# METHOD TO SELECTED CONTEXT MENU OPTIONS TO DISPLAY LINKED LIST BLOCK START ##################
		///*******PURPOSE: THIS IS USED TO SELECTED CONTEXT MENU OPTIONS TO DISPLAY NOT LINKED LIST
		///*******CREATED BY: MANOJ B   
		///*******CREATED DATE: 26TH MAY 2017
		///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************  

		var apptsInfoCustomizationSelectedContextMenuLinked = function (postData) {

			postData.practicemodel = EMRPracticeModel;
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonService.PostData('POST', CommonService.EHR_ApptSchedulerContextMenusandMoreOptionsCustomization_API() + "GetSelectedContextMenusorMoreOptionsList", postData).then(
				function (result) {
					return result;
				});
		};


		//############# METHOD TO GET THE LINLKED APPOINTMENT STATUS TO THIS PRACTICE  BLOCK START ##################
		///*******PURPOSE: THIS METHOD IS USED TO GET THE APPOINTMENT STATUS LINKED TO THIS PRACTICE GET LIST  
		///*******CREATED BY: AMARNATH
		///*******CREATED DATE: 06/13/2017
		///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************  

		var apptsInfoCustomizeAppointmentStatusLinkedToThisPracticeGetList = function (postData) {

			postData.practicemodel = EMRPracticeModel;
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonService.PostData('POST', CommonService.EHR_GlobalValueSet() + "AppointmentStatusLinkedToThisPracticeGetList", postData).then(
				function (result) {
					return result;
				});
		};
		//############# METHOD TO GET THE LINLKED APPOINTMENT STATUS TO THIS PRACTICE  BLOCK END ##################


		return {
			apptsInfoGetApptSchedulerApptsSettingsInfomationList: apptsInfoGetApptSchedulerApptsSettingsInfomationList,

			apptsInfoGetApptSchedulerApptsCustomizedColumnsInfomationList: apptsInfoGetApptSchedulerApptsCustomizedColumnsInfomationList,

			apptsInfoCustomizationSelectedContextMenuLinked: apptsInfoCustomizationSelectedContextMenuLinked,

			apptsInfoCustomizeAppointmentStatusLinkedToThisPracticeGetList: apptsInfoCustomizeAppointmentStatusLinkedToThisPracticeGetList,

		};
	}
})();